import styled from 'styled-components'

export const FeaturedAssetContainer = styled.div`
  position: relative;
  max-width: 1920px;
  margin: 0 auto;

  .absolute {
    position: absolute;
    z-index: 9;
    right: 40px;
    top: -152px;
    max-width: 430px;
    background-color: ${({ theme }) => theme.webMktNewPalette.background.light.default};
    box-shadow: -48px 48px 64px 0px #0000000f;
    ${({ theme }) => theme.breakpoints.down('lg')} {
      max-width: 280px;
      min-width: 280px;
    }
    ${({ theme }) => theme.breakpoints.down('sm')} {
      max-width: 240px;
      min-width: 240px;
      top: auto;
      right: 16px;
      bottom: -96px;
    }
    ${({ theme }) => theme.breakpoints.down('xs')} {
      min-width: 260px;
      bottom: -62px;
      position: relative;
      right: 16px;
      left: 16px;
      top: -60px;
      max-width: calc(100% - 32px);
    }
  }

  .FeaturedAsset__Image-Container {
    padding-bottom: 8px;
    overflow: hidden;
    background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
    .FeaturedAsset__Image {
      object-fit: cover;
      min-height: 240px;
      object-position: center;
      border: 4px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
      width: calc(100% - 8px);
      ${({ theme }) => theme.breakpoints.down('sm')} {
        min-height: 180px;
      }
      ${({ theme }) => theme.breakpoints.down('sm')} {
        min-height: 240px;
      }
    }
    .FeaturedAsset__Video {
      border: 4px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
      .VideoPlayer__Image-File {
        object-fit: cover;
        min-height: 240px;
        object-position: center;
      }
    }
  }

  .FeaturedAsset__Text-Container {
    padding: 24px;
    min-height: 210px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
    border-bottom: 2px solid ${({ theme }) => theme.webMktNewPalette.orange[50]};

    .FeaturedAsset__Type {
      color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
      text-transform: uppercase;
      margin-bottom: 32px;
      ${({ theme }) => theme.breakpoints.down('sm')} {
        margin-bottom: 16px;
      }
    }

    .FeaturedAsset__Title {
      color: ${({ theme }) => theme.webMktNewPalette.black};
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 16px;
      ${({ theme }) => theme.breakpoints.down('sm')} {
        font-size: 20px;
        font-weight: 600;
        line-height: 24px;
      }
    }
    .FeaturedAsset__Desc {
      margin-bottom: 16px;
      display: none;
    }
    .FeaturedAsset__CtaBox {
      margin-top: 16px;
      .CTA {
        padding: 16px 12px;

        .CTA__Arrow-Container {
          margin-left: 0;
        }
      }
    }
  }
`
